import { TextAlign } from "types/generic/types";

export const getTextAlignClassNames = ({
  defaultTextAlign,
  smTextAlign,
  mdTextAlign,
  lgTextAlign,
  xlTextAlign,
}: TextAlign) => {
  return {
    [`text-${defaultTextAlign || ""}`]: !!defaultTextAlign,
    [`text-sm-${smTextAlign || ""}`]: !!smTextAlign,
    [`text-md-${mdTextAlign || ""}`]: !!mdTextAlign,
    [`text-lg-${lgTextAlign || ""}`]: !!lgTextAlign,
    [`text-xl-${xlTextAlign || ""}`]: !!xlTextAlign,
  };
};
